<template>
    <div class="ConseilAccomp">
        <HeadPage :title="'Accompagnement de l\'entreprise et des salariés'" 
                  :category="'Conseil'"
                  :img="'conseil/accompagnement.png'"
                  :imgAlt="'Accompagnement head page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConseilAccomp",
    data() {
        return {
            content: [
                { 
                    text: [ `<strong>JobStream</strong> accompagne les TPE/PME dans la gestion de leurs ressources 
                    humaines (RH).`,
                    `<strong>Cette prestation de conseil</strong> permet à l'entreprise, de bénéficier d'un accompagnement personnalisé et favorise une <strong>gestion RH bien maîtrisée</strong> 
                    afin de :`,
                    `<ul>
                        <li>Participer au développement économique et à la stratégie de l'entreprise.</li>
                        <li>Permettre de préparer les transitions (passage des seuls sociaux, anticipation des départs en retraite, 
                        transmission des compétences)</li>
                        <li>Identifier le potentiel de création d'emploi et guider l'entreprise pour la préparation de son ou ses futures embauches</li>
                        <li>Assurer aux salariés des <strong>compétences professionnelles de qualité</strong> et participe à l'attractivité de l'entreprise</li>
                    </ul>`,
                    'Cette prestation est renforcée dans le contexte actuel de crise et permet :',
                    `<ul>
                        <li>De contribuer au <strong>maintien et au développement de l'emploi et des compétences</strong> dans la période de crise et de reprise 
                        économique, notamment pour les entreprises dont les salariés ont été indemnisés au titre de l'activité partielle ou 
                        qui ont bénéficié d'une convention de <a href="https://les-aides.fr/aide/V2FvchEUnw/dreets/fne-formation.html" target="_blank">FNE formation</a></li>
                        <li>D'aider l'entreprise à adapter son organisation du travail et sa gestion des ressources humaines au contexte 
                        de crise et de reprise progressive, en lien avec sa situation financière et sa stratégie de <strong>développement économique</strong></li>
                        <li>De co-construire des outils et un plan d'actions partagé par les acteurs de l'entreprise (direction-salariés-représentants des salariés lorsqu'ils existent) sur des thématiques spécifiques identifiées avec l'entreprise</li>
                        <li>D'accompagner la mise en oeuvre des actions en <strong>rendant l'entreprise autonome</strong> et en lui permettant l'appropriation des outils mis à sa disposition</li>
                    </ul>`
                        ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>